import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const checkbox = this.element.querySelector('.checkbox-switcher');
        const target = this.element.querySelector('.checkbox-target');
        const targetContent = this.element.querySelector('.checkbox-target-content');

        if (checkbox.dataset.canEdit === '1') {
            checkbox.addEventListener('change', () => {
                target.value = checkbox.checked ? 1 : 0;
                target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
                targetContent.style.display = targetContent.style.display === 'block' ? 'none' : 'block';
            });
        }
    }
}
